module.exports = __webpack_public_path__ + "img/product_placeholder.44d8fdb.jpg";